import React, { useState, useEffect } from "react";
import "../styles/meun.css";
import { CartMenuGroup } from "../components/KfcEl.js";
import { Indivdual, Share, BreakFast, Alacarte } from "../data/KfcMenuOptionChild.json"; //菜單子選項

// ================首頁=================
export function Index() {
  const [menus, setMenus] = useState([]); //菜單列表
  const optionChilds = { Indivdual, Share, BreakFast, Alacarte };

  useEffect(()=> {
    setMenus(optionChilds.Indivdual[0].list)
  },[optionChilds.Indivdual]);

  return (
      <div className="ShoppingCart">
        <nav>
          <img alt="" src="/images/logo.svg"></img>
        </nav>
        <div className="MenuKfcGroup">
          <div className="MenuKFC">
           {menus.map((menu, m) => {
            return <CartMenuGroup key={m} img={menu.img} name={menu.name} cost={m} price={menu.price} />
           })}
          </div>
        </div>
      </div>
    );
}
